"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabasesDisplayGrid = exports.databasesWithCrassCellFormatters = exports.columns = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
const ProjectLocationCellFormatter_1 = require("../datagrid/cellFormatters/ProjectLocationCellFormatter");
const UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
const shouldBeObfuscated = ({ name, }) => name === null;
function iconColumn(params) {
    const paramsOverride = Object.assign(Object.assign({}, params), { rowData: Object.assign(Object.assign({}, params.rowData), { isCertified: false }) });
    return react_1.default.createElement(data_catalog_shared_1.DatabaseMediumIcon, { database: paramsOverride.rowData });
}
function databaseGroupIcon(rowData) {
    if (!rowData.isGrouped) {
        return null;
    }
    return (react_1.default.createElement("div", { role: 'img', "aria-label": catalog_messages_1.Messages.GroupedAsset(), title: catalog_messages_1.Messages.GroupedAsset() },
        react_1.default.createElement(catalog_icons_1.SvgGroupPaperclip, null)));
}
function databaseLinkTitle(rowData) {
    return rowData.name;
}
function columns(siteUrls) {
    const columns = [
        (sortParams) => ({
            name: 'type',
            dataKey: catalog_queries_1.DatabaseOrderField.IS_CERTIFIED,
            headerText: catalog_messages_1.Messages.GridHeaderType(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createIconCellFormatter)((rowData) => iconColumn({
                rowData: rowData,
            }), (rowData) => (rowData.isCertified ? '' : (0, data_catalog_shared_1.getDatabaseIconTooltip)(rowData))),
            sortable: true,
            resizable: false,
        }),
        () => createLabelGridColumnFormatter(siteUrls, 'CERTIFICATION'),
        () => createLabelGridColumnFormatter(siteUrls, 'WARNING'),
        (params) => ({
            name: 'name',
            dataKey: catalog_queries_1.DatabaseOrderField.NAME,
            headerText: catalog_messages_1.Messages.GridHeaderName(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(params),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkWithIconCellFormatter)(shouldBeObfuscated, ({ name }) => name, // getTextFromRowData
            (urls, { id }) => urls.catalogDatabasePath(id), // getPathFromRowData
            false, // noPadding,
            true, // disableTabIndex
            ObfuscatedCellFormatter_1.PermissionsRequiredCell, // ObfuscatedComponent
            databaseGroupIcon, databaseLinkTitle, (rowData) => rowData.id === ''),
            growToFit: true,
            resizable: true,
            sortable: true,
        }),
        (sortParams) => ({
            name: 'virtualConnections',
            dataKey: catalog_queries_1.DatabaseOrderField.DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT,
            headerText: catalog_messages_1.Messages.GridHeaderVirtualConnection(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(({ downstreamVirtualConnectionsConnection }) => downstreamVirtualConnectionsConnection
                ? catalog_messages_1.Formatters.formatCount(downstreamVirtualConnectionsConnection.totalCount)
                : null),
            sortable: true,
        }),
        (sortParams) => ({
            name: 'workbooks',
            dataKey: catalog_queries_1.DatabaseOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
            headerText: catalog_messages_1.Messages.GridHeaderWorkbooks(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(({ downstreamWorkbooksConnection }) => downstreamWorkbooksConnection
                ? catalog_messages_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
                : null),
            sortable: true,
        }),
        (sortParams) => ({
            name: 'datasources',
            dataKey: catalog_queries_1.DatabaseOrderField.DOWNSTREAM_DATASOURCES_COUNT,
            headerText: catalog_messages_1.Messages.GridHeaderDatasources(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(({ downstreamDatasourcesConnection }) => downstreamDatasourcesConnection
                ? catalog_messages_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
                : null),
            sortable: true,
        }),
        (sortParams) => ({
            name: 'serverOrPath',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderServerOrPath(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter)(shouldBeObfuscated, data_catalog_shared_1.createServerOrPathString, undefined, // placeholder
            (rowData) => rowData.id === ''),
            resizable: true,
            sortable: false,
        }),
        (sortParams) => ({
            name: 'connectionType',
            dataKey: catalog_queries_1.DatabaseOrderField.CONNECTION_TYPE,
            headerText: catalog_messages_1.Messages.GridHeaderConnectionType(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter)(shouldBeObfuscated, (rowData) => (0, data_catalog_shared_1.messageForConnectionType)(rowData.connectionType), undefined, // placeholder
            (rowData) => rowData.id === ''),
            resizable: true,
            sortable: true,
        }),
        (sortParams) => ({
            name: 'contact',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderContact(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, UserNameCell_1.createUserNameLinkCellFormatter)(({ contact }) => contact, true, (rowData) => rowData.id === ''),
            resizable: true,
            sortable: false,
        }),
    ];
    return columns.filter(Boolean);
}
exports.columns = columns;
/**
 * @deprecated These cell formatters are already in use in the columns above. These defs below will be removed once we have
 * the columns used properly in vpc.
 */
const cellFormattersForCrass = {
    typeForCrass: {
        type: 'database',
        cellFormatter: (0, data_catalog_shared_1.createIconCellFormatter)((rowData) => iconColumn({
            rowData: rowData,
        }), (rowData) => (rowData.isCertified ? '' : (0, data_catalog_shared_1.getDatabaseIconTooltip)(rowData))),
    },
    name: {
        type: 'database',
        cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkWithIconCellFormatter)(shouldBeObfuscated, ({ name }) => name, // getTextFromRowData
        (urls, { id }) => urls.catalogDatabasePath(id), // getPathFromRowData
        false, // noPadding,
        true, // disableTabIndex
        ObfuscatedCellFormatter_1.PermissionsRequiredCell, // ObfuscatedComponent
        databaseGroupIcon, databaseLinkTitle, (rowData) => rowData.id === ''),
    },
    downstreamWorkbookCount: {
        type: 'database',
        cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(({ downstreamWorkbooksConnection }) => downstreamWorkbooksConnection
            ? catalog_messages_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
            : null),
    },
    downstreamDataSourcesCount: {
        type: 'database',
        cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(({ downstreamDatasourcesConnection }) => downstreamDatasourcesConnection
            ? catalog_messages_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
            : null),
    },
    serverOrPath: {
        type: 'database',
        cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter)(shouldBeObfuscated, data_catalog_shared_1.createServerOrPathString, undefined, // placeholder
        (rowData) => rowData.id === ''),
    },
    connectionTypeCrass: {
        type: 'database',
        cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter)(shouldBeObfuscated, (rowData) => (0, data_catalog_shared_1.messageForConnectionType)(rowData.connectionType), undefined, // placeholder
        (rowData) => rowData.id === ''),
    },
    contact: {
        type: 'database',
        cellFormatter: (0, UserNameCell_1.createUserNameLinkCellFormatter)(({ contact }) => contact, true, (rowData) => rowData.id === ''),
    },
    databaseProjectLocation: {
        type: 'database',
        cellFormatter: (0, ProjectLocationCellFormatter_1.createProjectLocationLinkCellFormatter)((rowData) => {
            return rowData.containerId === undefined ? null : rowData.containerId;
        }, (rowData) => {
            return rowData.containerName === undefined ? null : rowData.containerName;
        }, true, (rowData) => {
            return rowData.isEmbedded === undefined ? null : rowData.isEmbedded;
        }, (rowData) => rowData.id === ''),
    },
};
// eslint-disable-next-line deprecation/deprecation
exports.databasesWithCrassCellFormatters = cellFormattersForCrass;
function DatabasesDisplayGrid(props) {
    const { publishedConnectionsLineageEnabled } = (0, catalog_core_1.useFeatureFlags)();
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const cols = columns(siteUrls)
        .map((columnFactory) => columnFactory(props))
        .filter(column => {
        if (column.name === 'virtualConnections' && !publishedConnectionsLineageEnabled) {
            return false;
        }
        return true;
    });
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.DatabasesDisplayGrid = DatabasesDisplayGrid;
function getLabelContentFromRowData(rowData, urls) {
    var _a;
    return {
        contentId: rowData.id,
        contentLuid: rowData.luid,
        contentType: rowData.contentType,
        contentName: (_a = rowData.name) !== null && _a !== void 0 ? _a : undefined,
        contentUrl: urls.catalogDatabaseUrl(rowData.id),
        subjectArea: rowData.contentType,
    };
}
function createLabelGridColumnFormatter(urls, category) {
    function getPropsFromRowData(rowData) {
        const labels = rowData.labels ? rowData.labels : [];
        const content = getLabelContentFromRowData(rowData, urls);
        return (0, LabelsHookHelper_1.getLabelParamsForGrids)({ category, labels, urls, source: 'databases', content });
    }
    return (0, data_catalog_shared_1.createLabelColumnFormatter)((0, LabelsHookHelper_1.labelCategoryToString)(category), {
        overrides: {},
        getPropsFromRowData,
    });
}
//# sourceMappingURL=DatabasesDisplayGrid.js.map